export interface TeamScopeOption {
  id: string;
}

export function resolveActiveTeamId(
  profileActiveTeamId: string | null,
  userTeams: TeamScopeOption[],
): string | null {
  if (profileActiveTeamId && userTeams.some((team) => team.id === profileActiveTeamId)) {
    return profileActiveTeamId;
  }

  if (userTeams.length >= 1) {
    return userTeams[0].id;
  }

  return null;
}

export function resolveTeamScopedFilter(
  selectedTeamId: string | null,
  activeTeamId: string | null,
): string | null {
  return selectedTeamId ?? activeTeamId ?? null;
}
